import { render, staticRenderFns } from "./dev-tools-panel.vue?vue&type=template&id=a1385aa4&scoped=true"
import script from "./dev-tools-panel.vue?vue&type=script&lang=js"
export * from "./dev-tools-panel.vue?vue&type=script&lang=js"
import style0 from "./dev-tools-panel.vue?vue&type=style&index=0&id=a1385aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1385aa4",
  null
  
)

export default component.exports